import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M30.39 43.97C46.0749 43.97 58.79 34.5545 58.79 22.9399C58.79 11.3254 46.0749 1.91003 30.39 1.91003C14.7051 1.91003 1.98999 11.3254 1.98999 22.9399C1.98999 34.5545 14.7051 43.97 30.39 43.97Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </g>
  )
}
